/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/sort-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { timeText } from '../../../utils/time';
import Icon from '../../components/Icon';

const merge = require('deepmerge');

export default class DefaultCell extends React.Component {
    state = {
        isFocused: false
    };

    theme = this.props.data.getLandscapeTheme()
        ? merge(this.props.theme, this.props.data.getLandscapeTheme())
        : this.props.theme;

    shouldComponentUpdate(nextProps, nextState) {
        return (
            nextProps.style.left !== this.props.style.left ||
            nextProps.style.top !== this.props.style.top ||
            nextProps.style.width !== this.props.style.width ||
            nextProps.data.getTitle() !== this.props.data.getTitle() ||
            nextProps.forceUpdate !== this.props.forceUpdate ||
            nextState.isFocused !== this.state.isFocused ||
            this.props.isPlayingNow !== nextProps.isPlayingNow
        );
    }

    handleFocus = () => {
        this.setState({ isFocused: true });
    };

    handleBlur = () => {
        this.setState({ isFocused: false });
    };

    renderTitleBlock = () => {
        const { data, lockedContentTitle } = this.props;
        const { isFocused } = this.state;

        const title = (
            <span
                style={{
                    ...(this.isPlayingNow ? this.theme.title : this.theme.title),
                    overflow: isFocused ? 'visible' : 'hidden',
                    textOverflow: 'ellipsis',
                    ...(isFocused && {
                        width: this.theme?.title?.width || 'auto'
                    }),
                    textAlign: 'justify',
                    ...(data.data.isLocked && this.theme.lockedTitle)
                }}
            >
                {data.data.isLocked ? lockedContentTitle || data.getTitle() : data.getTitle()}
            </span>
        );

        return data.getIcons() && data.getIcons().length > 0 ? (
            <div style={this.theme.titleContainerWithIcon}>
                {title}
                {data.getIcons().length > 0 &&
                    data
                        .getIcons()
                        ?.filter((_, i) => data?.data?.iconsAsString?.[i] !== 'archive')
                        .map((icon, i) => (
                            <Icon
                                name={icon}
                                key={`${icon}${i}${data.getId()}`}
                                style={this.theme.icon}
                            />
                        ))}
            </div>
        ) : (
            title
        );
    };

    render() {
        const { isFocused } = this.state;
        const { style, data, innerRef, isPlayingNow, onPressCell, is12HourClock } = this.props;
        return (
            <button
                onFocus={this.handleFocus}
                onBlur={this.handleBlur}
                onMouseOver={this.handleFocus}
                onMouseOut={this.handleBlur}
                style={{
                    ...style,
                    ...(isPlayingNow ? this.theme.activeContainer : this.theme.container),
                    ...(isFocused && {
                        zIndex: 20,
                        width: 'auto',
                        backgroundColor: isPlayingNow ? '#2d3037' : '#10141a'
                    }),
                    minWidth: style.width,
                    border: `${this.theme.container.borderWidth}px solid ${this.theme.container.borderColor}`,
                    whiteSpace: 'nowrap',
                    padding: 0,
                    outline: 'none'
                }}
                ref={innerRef}
                className="cell"
                type="button"
                onClick={() => onPressCell(data)}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        height: '100%',
                        maxWidth: '100%',
                        cursor: 'pointer',
                        outline: 'none',
                        transition:
                            'padding .3s ease-in-out,max-width .3s ease-in-out,z-index .3s ease-in-out',
                        paddingLeft: isFocused
                            ? this.theme.container.paddingHorizontal
                            : style.width > 55
                              ? this.theme.container.paddingHorizontal
                              : 0,
                        paddingRight: isFocused
                            ? this.theme.container.paddingHorizontal
                            : style.width > 55
                              ? this.theme.container.paddingHorizontal
                              : 0
                    }}
                >
                    {this.renderTitleBlock()}

                    <span
                        style={{
                            ...(isPlayingNow ? this.theme.description : this.theme.description),
                            overflow: isFocused ? 'visible' : 'hidden',
                            textOverflow: 'ellipsis',
                            ...(isFocused && {
                                width: 'auto'
                            }),
                            textAlign: 'justify'
                        }}
                    >
                        {`${timeText(
                            new Date(data.getStart()),
                            new Date(data.getEnd()),
                            is12HourClock
                        )} | ${data.getGenre()}`}
                    </span>
                </div>
            </button>
        );
    }
}

DefaultCell.propTypes = {
    data: PropTypes.object,
    innerRef: PropTypes.func,
    isPlayingNow: PropTypes.bool,
    style: PropTypes.object,
    theme: PropTypes.object,
    onPressCell: PropTypes.func
};

DefaultCell.defaultProps = {
    data: {},
    innerRef: () => {},
    onPressCell: () => {},
    style: {},
    theme: {},
    isPlayingNow: false
};
